import React from 'react';

import { Logo } from '@repo/ui/deprecated/Logo';
import { H3, P2 } from '@repo/ui-kit/components/core/Typography';

import {
  SurveyOptionList,
  SurveyOption as SurveyOptionStyled,
  Wrapper,
  ProgressContainer,
  ProgressDot,
  HeaderWrapper,
  OptionContent,
} from './styles';

const TOTAL_STEP_COUNT = 4;

interface OptionProps {
  onClick: () => void;
  label: string;
  icon?: React.ComponentType;
  isDisabled?: boolean;
}

export const SimpleSurvey = {
  Root: ({ children }: { children: React.ReactNode }): React.JSX.Element => (
    <Wrapper>{children}</Wrapper>
  ),

  Header: ({
    title,
    step,
  }: {
    title: string;
    step: number;
  }): React.JSX.Element => (
    <HeaderWrapper>
      <Logo />
      <ProgressContainer>
        {Array.from({ length: TOTAL_STEP_COUNT }, (_, i) => i + 1).map(
          (num) => (
            <ProgressDot key={num} active={num === step} />
          )
        )}
      </ProgressContainer>
      <H3>{title}</H3>
    </HeaderWrapper>
  ),

  Option: ({
    onClick,
    label,
    icon: Icon,
    isDisabled,
  }: OptionProps): React.JSX.Element => (
    <SurveyOptionStyled
      isDisabled={isDisabled}
      role="button"
      onClick={isDisabled ? undefined : onClick}
    >
      <OptionContent>
        {Icon && <Icon />}
        <P2>{label}</P2>
      </OptionContent>
    </SurveyOptionStyled>
  ),

  List: ({ children }: { children: React.ReactNode }): React.JSX.Element => (
    <SurveyOptionList>{children}</SurveyOptionList>
  ),
};
